import styled from 'styled-components';
import MobileDropdown from '../Shared/mobile-dropdown';
import MobileBasemapOptions from './mobile-basemap-options';
import Analytics from '../../../lib/user-analytics';

const MobileBasemapMenu = () => {
    const handleBasemapMenu = () => {
        Analytics.Event('Mobile Map Container', 'Clicked Mobile Basemap menu');
    };
    return (
        <MobileDropdown
            top="63px"
            right="8px"
            containerheight="360px"
            dropdownIcon={
                <BasemapIconContainer onClick={handleBasemapMenu}>
                    <BasemapIcon onClick={handleBasemapMenu} />
                </BasemapIconContainer>
            }
        >
            <MobileBasemapOptions />
        </MobileDropdown>
    );
};

export default MobileBasemapMenu;

const BasemapIcon = styled.a`
    background-color: rgba(0, 0, 0, 0.75) !important;
    width: 37px !important;
    height: 37px !important;
    background-repeat: no-repeat !important;
    background-size: 24px !important;
    background-position: 7px 7px !important;
    border-radius: 6px !important;
    display: table-cell;
    background: url('data:image/svg+xml,%3Csvg%20width%3D%2222%22%20height%3D%2222%22%20viewBox%3D%220%200%2022%2022%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M1%207.93861L11%201L21%207.93861L11%2014.4691L1%207.93861Z%22%20stroke%3D%22white%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M1%2011.2045L0.718466%2010.7913C0.580354%2010.8854%200.498388%2011.0423%200.500024%2011.2094C0.50166%2011.3765%200.586682%2011.5318%200.72661%2011.6232L1%2011.2045ZM11%2017.735L10.7266%2018.1536C10.8927%2018.2621%2011.1073%2018.2621%2011.2734%2018.1536L11%2017.735ZM21%2011.2045L21.2734%2011.6232C21.4127%2011.5322%2021.4976%2011.3779%2021.5%2011.2115C21.5023%2011.0452%2021.4217%2010.8886%2021.285%2010.7937L21%2011.2045ZM0.72661%2011.6232L10.7266%2018.1536L11.2734%2017.3163L1.27339%2010.7859L0.72661%2011.6232ZM20.7266%2010.7859L10.7266%2017.3163L11.2734%2018.1536L21.2734%2011.6232L20.7266%2010.7859ZM18.2598%209.91177L20.715%2011.6153L21.285%2010.7937L18.8299%209.09018L18.2598%209.91177ZM3.21847%209.08797L0.718466%2010.7913L1.28153%2011.6177L3.78153%209.91438L3.21847%209.08797Z%22%20fill%3D%22white%22%2F%3E%0A%3Cpath%20d%3D%22M1%2014.4695L0.714964%2014.0587C0.578275%2014.1536%200.497713%2014.3102%200.500049%2014.4765C0.502385%2014.6429%200.587312%2014.7972%200.72661%2014.8882L1%2014.4695ZM11%2021L10.7266%2021.4186C10.8927%2021.5271%2011.1073%2021.5271%2011.2734%2021.4186L11%2021ZM21%2014.4695L21.2734%2014.8882C21.4127%2014.7972%2021.4976%2014.6429%2021.5%2014.4765C21.5023%2014.3102%2021.4217%2014.1536%2021.285%2014.0587L21%2014.4695ZM0.72661%2014.8882L10.7266%2021.4186L11.2734%2020.5813L1.27339%2014.0509L0.72661%2014.8882ZM20.7266%2014.0509L10.7266%2020.5813L11.2734%2021.4186L21.2734%2014.8882L20.7266%2014.0509ZM18.362%2013.2477L20.715%2014.8803L21.285%2014.0587L18.9321%2012.4261L18.362%2013.2477ZM3.06791%2012.4261L0.714964%2014.0587L1.28504%2014.8803L3.63798%2013.2477L3.06791%2012.4261Z%22%20fill%3D%22white%22%2F%3E%0A%3C%2Fsvg%3E%0A');
`;

const BasemapIconContainer = styled.div`
    position: fixed;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 6px;
    top: 62px;
    right: 7px;
    border-radius: 6px;
`;
